import { render, staticRenderFns } from "./categoryApp.vue?vue&type=template&id=6ec525a5&"
import script from "./categoryApp.vue?vue&type=script&lang=js&"
export * from "./categoryApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports